module.exports = __webpack_public_path__ + "assets/img/img-placeholder-reel-w1460.0d054089.jpg";